export const buildGroupedLabel = (option) => {
    const label = document.createElement('span');
    label.className = 'grouped-label';

    const group = document.createElement('span');
    group.className = 'group';
    group.textContent = option.dataset.group;

    const separator = document.createElement('i');
    separator.className = 'fa-solid fa-chevron-right';

    const name = document.createElement('span');
    name.className = 'name';
    name.textContent = option.dataset.name;

    label.append(group, separator, name);

    return label;
};
